import { render, staticRenderFns } from "./Workstation.vue?vue&type=template&id=9388d01a&scoped=true"
import script from "./Workstation.vue?vue&type=script&lang=js"
export * from "./Workstation.vue?vue&type=script&lang=js"
import style0 from "./Workstation.vue?vue&type=style&index=0&id=9388d01a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9388d01a",
  null
  
)

export default component.exports